import {
  NEVER,
  type Observable,
  catchError,
  firstValueFrom,
  merge,
} from "rxjs";

export function mergeSkipError(...obs: Array<Observable<any>>) {
  return merge(
    ...obs.map((ob) =>
      ob.pipe(
        catchError((error) => {
          console.error(error);
          return NEVER;
        })
      )
    )
  );
}

export async function ToPromise<T>(obs: Observable<T>): Promise<T | undefined> {
  try {
    return await firstValueFrom(obs);
  } catch (error) {
    if (error instanceof Error && error.name === "EmptyError") {
      return undefined;
    }
    throw error;
  }
}
